import { useState, useEffect } from "react";
import {
  getWorkThroughput,
  getWorkTimeInPosition,
  getClientWaitingTime,
} from "../../../../api/hub/work";

const useWorkCharts = (clientId) => {
  const [throughputData, setThroughputData] = useState([]);
  const [positionData, setPositionData] = useState([]);
  const [waitingData, setWaitingData] = useState([]);
  const [throughputLoading, setThroughputLoading] = useState(true);
  const [positionLoading, setPositionLoading] = useState(true);
  const [waitingLoading, setWaitingLoading] = useState(true);

  useEffect(() => {
    if (!clientId) { setThroughputLoading(false); return; }
    let cancelled = false;
    setThroughputLoading(true);
    getWorkThroughput(clientId)
      .then((r) => { if (!cancelled) { setThroughputData(r?.data || []); setThroughputLoading(false); } })
      .catch(() => { if (!cancelled) { setThroughputData([]); setThroughputLoading(false); } });
    return () => { cancelled = true; };
  }, [clientId]);

  useEffect(() => {
    if (!clientId) { setPositionLoading(false); return; }
    let cancelled = false;
    setPositionLoading(true);
    getWorkTimeInPosition(clientId)
      .then((r) => { if (!cancelled) { setPositionData(r?.data || []); setPositionLoading(false); } })
      .catch(() => { if (!cancelled) { setPositionData([]); setPositionLoading(false); } });
    return () => { cancelled = true; };
  }, [clientId]);

  useEffect(() => {
    if (!clientId) { setWaitingLoading(false); return; }
    let cancelled = false;
    setWaitingLoading(true);
    getClientWaitingTime(clientId)
      .then((r) => { if (!cancelled) { setWaitingData(r?.data || []); setWaitingLoading(false); } })
      .catch(() => { if (!cancelled) { setWaitingData([]); setWaitingLoading(false); } });
    return () => { cancelled = true; };
  }, [clientId]);

  return {
    throughputData,
    positionData,
    waitingData,
    chartsLoading: throughputLoading || positionLoading || waitingLoading,
  };
};

export default useWorkCharts;
